import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "../components/site/Navbar";
import Hero from "../components/site/Hero";
import Features from "../components/site/Features";
import HowItWorks from "../components/site/HowItWorks";
import UseCases from "../components/site/UseCases";
import Roles from "../components/site/Roles";
import Pricing from "../components/site/Pricing";
import FAQ from "../components/site/FAQ";
import CTA from "../components/site/CTA";
import Footer from "../components/site/Footer";

const Home = () => {
  const location = useLocation();

  // Support deep-link anchors like /#pricing coming from other routes
  useEffect(() => {
    const hash = location.pathname.replace("/", "");
    if (hash.startsWith("#")) {
      setTimeout(() => {
        document.querySelector(hash)?.scrollIntoView({ behavior: "smooth" });
      }, 100);
    }
  }, [location]);

  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <main>
        <Hero />
        <Features />
        <HowItWorks />
        <UseCases />
        <Roles />
        <Pricing />
        <FAQ />
        <CTA />
      </main>
      <Footer />
    </div>
  );
};

export default Home;
